import { AreaUnit, Currency } from '../../graphql/graphql';

const currencyMap = {
  [AreaUnit.Acres]: {
    sign: '$',
    name: Currency.Usd,
  },
  [AreaUnit.Hectares]: {
    sign: '€',
    name: Currency.Eur,
  },
} as Record<AreaUnit, { sign: string; name: Currency }>;

export const getCurrencyForAreaUnit = (areaUnit: AreaUnit): Currency =>
  currencyMap[areaUnit].name;

export const getCurrencySignForAreaUnit = (areaUnit: AreaUnit): string =>
  currencyMap[areaUnit].sign;
